var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { id: "product-safety-modal", tabindex: "-1", role: "dialog" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-scrollable modal-dialog-centered",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title h3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$translate(
                        "modeherz::SingleItemPageClient.itemProductSafetyHeader"
                      )
                    ) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-hidden": "true",
                  },
                },
                [_vm._v("\n                    ×\n                ")]
              ),
            ]),
            _vm._v(" "),
            !_vm.productSafetyLoaded
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [_c("loading-animation", {})],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "modal-body p-4" },
                  [
                    _c("h4", { staticClass: "mb-3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "modeherz::SingleItemPageClient.itemProductSafetyEuResponsibleDescription"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.euResponsiblePerson
                      ? [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.euResponsiblePerson.name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.euResponsiblePerson.addressLine1)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm.euResponsiblePerson.addressLine2
                            ? [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.euResponsiblePerson.addressLine2)
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.euResponsiblePerson.countryCode) +
                              " " +
                              _vm._s(_vm.euResponsiblePerson.zipCode) +
                              " " +
                              _vm._s(_vm.euResponsiblePerson.city)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm.euResponsiblePerson.email
                            ? [
                                _c("i", {
                                  staticClass: "far fa-envelope mr-1",
                                }),
                                _vm._v(_vm._s(_vm.euResponsiblePerson.email)),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.euResponsiblePerson.phone
                            ? [
                                _c("i", {
                                  staticClass:
                                    "far fa-phone-alt fa-flip-horizontal mr-1",
                                }),
                                _vm._v(_vm._s(_vm.euResponsiblePerson.phone)),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.euResponsiblePerson.contactUrl
                            ? [
                                _c("i", { staticClass: "fa fa-sign-out mr-1" }),
                                _vm._v(
                                  _vm._s(_vm.euResponsiblePerson.contactUrl)
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                        ]
                      : [
                          _c("i", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$translate(
                                    "modeherz::SingleItemPageClient.itemProductSafetyEuResponsibleNotAvailable"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }